export default "__VITE_ASSET__BCTOSyDA__"